import "bootstrap/dist/css/bootstrap.min.css";
import "leaflet/dist/leaflet.css";
import "index.css";
import "./themes/theme-loader";

import ReactDOM from "react-dom/client";
import App from "App";
import {I18nextProvider} from "react-i18next";
import i18n from "./core/i18n";

// -
import {library} from "@fortawesome/fontawesome-svg-core";
import fwIcons from "./core/fw-icons";

library.add(fwIcons);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <I18nextProvider i18n={i18n}>
        <App />
    </I18nextProvider>
);
